/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3Deal } from '../models/V3Deal';
import { HttpFile } from '../http/http';

export class V3ListXandrDealsResponse {
    'deals'?: Array<V3Deal>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "deals",
            "baseName": "deals",
            "type": "Array<V3Deal>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3ListXandrDealsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

